import { api } from "@/libs/api-client";
import type { ApiDataResponse } from "@/types/api-types";
import { proxyImg } from "@/utils/tmp";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import type { User } from "../types";

export const userQuerySchema = z.union([
  z.object({
    id: z.string(),
  }),
  z.object({
    username: z.string(),
  }),
]);

export type GetUserInput = z.infer<typeof userQuerySchema>;

export const getUser = createServerFn({ method: "GET" })
  .validator(userQuerySchema)
  .handler<User>(async ({ data }) => {
    if ("id" in data) {
      const response = await api
        .post("user/getUserProfile", {
          searchParams: {
            userId: data.id,
          },
        })
        .json<
          ApiDataResponse<{
            userId: string;
            userName: string;
            nickName: string;
            introduction: string;
            avatarUrl: string;
          }>
        >();

      return {
        userId: response.data.userId,
        username: response.data.userName,
        nickname: response.data.nickName ?? response.data.userName,
        bio: response.data.introduction ?? "",
        avatarUrl: proxyImg(
          response.data.avatarUrl ??
            `https://api.dicebear.com/9.x/pixel-art/svg?seed=${response.data.userId}`,
        ),
      };
    }

    throw new Error("Not implemented");
  });
